const buttons = {};

export default buttons;
